import { render } from "./TeamDisplayDraftPlayer.vue?vue&type=template&id=66d08c60&scoped=true"
import script from "./TeamDisplayDraftPlayer.vue?vue&type=script&lang=js"
export * from "./TeamDisplayDraftPlayer.vue?vue&type=script&lang=js"

import "./TeamDisplayDraftPlayer.vue?vue&type=style&index=0&id=66d08c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d08c60"]])

export default __exports__